import { Injectable } from '@angular/core';
import { Veiculo } from '@tivic-team/manager-ts/dist/fta/entities/veiculo.entity';
import { Pessoa } from '@tivic-team/manager-ts/dist/grl';
import { ConcessaoVeiculo } from '@tivic-team/manager-ts/dist/mob/entities/concessao/concessao-veiculo.entity';
import { ConcessaoVeiculoDTO, ConcessaoVeiculoListDTO } from 'app/model/dtos/mob/concessao-veiculo.dto';
import { VeiculoEquipamentoDTO } from 'app/model/dtos/mob/veiculo-equipamento.dto';
import { HttpGet, HttpPost, HttpPut, HttpResponse, JSONData, Quark, Url } from 'sol-request-angular/dist/comunicacao';
import { IFilter } from 'sol-request-angular/dist/comunicacao/interfaces/IFilter';
import { environment } from 'src/environments/environment';
import { environmentv3 } from 'src/environments/environmentv3';
import { RelatorioConessaoVeiculoListDTO } from '../../model/dtos/mob/relatorio-concessao-veiculo.dto';

@Injectable()
export class ConcessaoVeiculoController {

  constructor() { }

    async findConcessaoVeiculos(filtros?: IFilter): Promise<Array<ConcessaoVeiculoDTO>> {
      let quark = new Quark(
        new HttpGet({
          url: new Url({
            id: 'mob/concessoesveiculos',
            environment: environment,
            filter: filtros
          }),
        }),
        new HttpResponse(
          new Array<ConcessaoVeiculoDTO>()
        )
      );
      return await quark.call();
    }

    async find(filtros?: IFilter): Promise<ConcessaoVeiculoDTO[]> {
      let quark = new Quark(
        new HttpGet({
          url: new Url({
            id: 'mob/concessoesveiculos/veiculoconcessao',
            environment: environmentv3,
            filter: filtros
          }),
        }),
        new HttpResponse(
          new Array<ConcessaoVeiculoDTO>()
        )
      );
      return await quark.call();
    }

    async getVeiculoConcessao(cdConcessaoVeiculo: number): Promise<ConcessaoVeiculoDTO> {
      let quark = new Quark(
        new HttpGet({
          url: new Url({
            id: 'mob/concessoesveiculos/:cdConcessaoVeiculo',
            environment: environment,
            pathParams: new JSONData({ cdConcessaoVeiculo: cdConcessaoVeiculo })
          }),
        }),
        new HttpResponse(
          new ConcessaoVeiculoDTO()
        )
      );
      return await quark.call();
    }

    async createVeiculo(concessaoVeiculoDTO: ConcessaoVeiculoDTO): Promise<ConcessaoVeiculoDTO> {
      let quark = new Quark(
        new HttpPost({
          url: new Url({
            id: 'mob/concessoesveiculos',
            environment: environmentv3
          }),
          data: new JSONData(concessaoVeiculoDTO)
        }),
        new HttpResponse(
          new ConcessaoVeiculoDTO()
        )
      );
      return await quark.call();
    }

    async updateVeiculo(concessaoVeiculoDTO: ConcessaoVeiculoDTO): Promise<ConcessaoVeiculoDTO> {
      let quark = new Quark(
        new HttpPut({
          url: new Url({
            id: 'mob/concessoesveiculos/:cdConcessaoVeiculo',
            environment: environmentv3,
            pathParams: new JSONData({ cdConcessaoVeiculo: concessaoVeiculoDTO.cdConcessaoVeiculo })
          }),
          data: new JSONData(concessaoVeiculoDTO)
        }),
        new HttpResponse(
          new ConcessaoVeiculoDTO()
        )
      );
      return await quark.call();
    }

    async get(cdConcessaoVeiculo: number): Promise<ConcessaoVeiculoDTO> {
      let quark = new Quark(
        new HttpGet({
          url: new Url({
            id: 'mob/concessoesveiculos/:cdConcessaoVeiculo',
            environment: environmentv3,
            pathParams: new JSONData({ cdConcessaoVeiculo: cdConcessaoVeiculo })
          }),
        }),
        new HttpResponse(
          new ConcessaoVeiculoDTO()
        )
      );
      return await quark.call();
    }

    async desvincular(concessaoVeiculo: ConcessaoVeiculoDTO): Promise<ConcessaoVeiculoDTO> {
      let quark = new Quark(
        new HttpPut({
          url: new Url({
            id: 'mob/concessoesveiculos/:cdConcessaoVeiculo/desvincular',
            environment: environmentv3,
            pathParams: new JSONData({ cdConcessaoVeiculo: concessaoVeiculo.cdConcessaoVeiculo })
          }),
          data: new JSONData(concessaoVeiculo)
        }),
        new HttpResponse(
          new ConcessaoVeiculoDTO()
        )
      );
      return await quark.call();
    }

    async getEquipamentosByConcessaoVeiculo(cdConcessaoVeiculo: number): Promise<VeiculoEquipamentoDTO[]> {
      let quark = new Quark(
        new HttpGet({
          url: new Url({
            id: 'mob/concessoesveiculos/:cdConcessaoVeiculo/equipamentos',
            environment: environmentv3,
            pathParams: new JSONData({ cdConcessaoVeiculo: cdConcessaoVeiculo })
          }),
        }),
        new HttpResponse(
          new Array<VeiculoEquipamentoDTO>()
        )
      );
      return await quark.call();
    }

    async getConcessionario(nrPrefixo: number): Promise<Pessoa> {
      let quark = new Quark(
        new HttpGet({
          url: new Url({
            id: 'mob/concessoesveiculos/concessionario/:nrPrefixo',
            environment: environment,
            pathParams: new JSONData({ nrPrefixo: nrPrefixo })
          }),
        }),
        new HttpResponse(
          new Pessoa()
        )
      );
      return await quark.call();
    }

    async getConcessao(nrPrefixo: number): Promise<ConcessaoVeiculo> {
      let quark = new Quark(
        new HttpGet({
          url: new Url({
            id: 'mob/concessoesveiculos/concessao/:nrPrefixo',
            environment: environment,
            pathParams: new JSONData({ nrPrefixo: nrPrefixo })
          }),
        }),
        new HttpResponse(
          new ConcessaoVeiculo()
        )
      );
      return await quark.call();
    }

    async getVeiculo(cdConcessaoVeiculo: number): Promise<Veiculo> {
      let quark = new Quark(
        new HttpGet({
          url: new Url({
            id: 'mob/concessoesveiculos/:cdConcessaoVeiculo/veiculo',
            environment: environmentv3,
            pathParams: new JSONData({ cdConcessaoVeiculo: cdConcessaoVeiculo })
          }),
        }),
        new HttpResponse(
          new Veiculo
        )
      );
      return await quark.call();
    }

    async getVeiculosByConcessao(cdConcessao: number, filtros?: IFilter): Promise<ConcessaoVeiculoDTO[]> {
      let quark = new Quark(
        new HttpGet({
          url: new Url({
            id: 'mob/concessoesveiculos/:cdConcessao/veiculos',
            environment: environmentv3,
            pathParams: new JSONData({ cdConcessao: cdConcessao }),
            filter: filtros
          }),
        }),
        new HttpResponse(
          new Array<ConcessaoVeiculoDTO>()
        )
      );
      return await quark.call();
    }

    async findConcessaoVeiculo(filtros?: IFilter): Promise<ConcessaoVeiculoListDTO> {
      let quark = new Quark(
        new HttpGet({
          url: new Url({
            id: 'mob/concessoesveiculos',
            environment: environmentv3,
            filter: filtros
          }),
        }),
        new HttpResponse(
          new ConcessaoVeiculoListDTO()
        )
      );
      return await quark.call();
    }

    async getVeiculoByPlaca(nrPlaca: String): Promise<ConcessaoVeiculoDTO> {
      let quark = new Quark(
        new HttpGet({
          url: new Url({
            id: 'mob/concessoesveiculos/veiculo/:nrPlaca',
            environment: environmentv3,
            pathParams: new JSONData({ nrPlaca: nrPlaca })
          }),
        }),
        new HttpResponse(
          new ConcessaoVeiculoDTO
        )
      );
      return await quark.call();
    }

    async relatorioConcessaoVeiculo(filtros?: IFilter): Promise<RelatorioConessaoVeiculoListDTO> {
      let quark = new Quark(
        new HttpGet({
          url: new Url({
            id: 'mob/concessoesveiculos/relatorioveiculos',
            environment: environmentv3,
            filter: filtros
          }),
        }),
        new HttpResponse(
          new Array<RelatorioConessaoVeiculoListDTO>()
        )
      );
      return await quark.call();
    }

    async getRelatorioConcessaoVeiculo(filtros?: IFilter): Promise<Blob> {
      let quark = new Quark(
        new HttpGet({
          url: new Url({
            id: 'mob/concessoesveiculos/relatorio',
            environment: environmentv3,
            filter: filtros
          }),
          responseType: 'Blob'
        }),
        new HttpResponse(
          new Blob
        )
      );
      return await quark.call();
    }

    async findVeiculos(filtros?: IFilter): Promise<Array<ConcessaoVeiculoDTO>> {
      const quark = new Quark(
        new HttpGet({
          url: new Url({
            id: 'mob/concessoesveiculos/veiculos',
            environment: environmentv3,
            filter: filtros
          }),
        }),
        new HttpResponse(
          new Array<ConcessaoVeiculoDTO>()
        )
      );
      return await quark.call();
    }

    async findVeiculosByConcessao(filtros?: IFilter): Promise<Array<ConcessaoVeiculo>> {
      const quark = new Quark(
        new HttpGet({
          url: new Url({
            id: 'mob/concessoesveiculos/concessao/veiculos',
            environment: environmentv3,
            filter: filtros
          }),
        }),
        new HttpResponse(
          new Array<ConcessaoVeiculo>()
        )
      );
      return await quark.call();
    }
  }